import { render, staticRenderFns } from "./OffProduct.vue?vue&type=template&id=1545f7d0&scoped=true"
import script from "./OffProduct.vue?vue&type=script&lang=js"
export * from "./OffProduct.vue?vue&type=script&lang=js"
import style0 from "./OffProduct.vue?vue&type=style&index=0&id=1545f7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1545f7d0",
  null
  
)

export default component.exports